const appassets = {
  // signupBackground: '/images/background-login.png', // old  image
  signupBackground: '/images/background-login.svg',
  recruiterIcon: '/images/recruitment1.svg',
  recruiterSignupPerson: '/images/person.svg',
  recruiterSignupWork: '/images/work.svg',
  recruiterSignupDollar: '/images/currency.svg',
  hire: '/images/hire.svg',
  checkGIF: '/images/checkgif.gif',

  location: '/images/location.svg',
  suitcase: '/images/suitcase.svg',
  skill: '/images/skills.svg',
  // time: '/images/time.svg', // instead of this I use new icon
  copy: '/images/copy.svg',
  editJob: '/images/edit.svg',
  close: '/images/close.png',
  jobPending: '/images/pending.svg',
  arrowRight: '/images/arrowRight.svg',
  hold: '/images/hold.svg',
  userActive: '/images/userActive.svg',
  time: '/images/timeClock.svg',

  basicDetails: '/images/basic-details.svg',
  companyDetails: '/images/company-details.svg',

  sendWhite: '/images/send-white.svg',
  addWhite: '/images/add-white.svg',
  review: '/images/eye-1.svg',
  pending: '/images/eye-2.svg',
  submit: '/images/send.svg',
  notSubmitted: '/images/not.svg',
  edit: '/images/edit.svg',
  email: '/images/email.svg',
  contact: '/images/contact.svg',
  call: '/images/call.svg',
  cv: '/images/cv.svg',
  help: '/images/help.svg',
  logout: '/images/logout.svg',

  user: '/images/user.svg',

  employerIcon: '/images/employment1.svg',
  employerImg: '/images/employer-signup-form.svg',
  fb: '/images/fb.svg',
  in: '/images/linked-in.svg',
  twitter: '/images/twitter.svg',
  mail: '/images/mail.png',

  step1: '/images/step1.png',
  step2: '/images/step2.png',
  step3: '/images/step3.png',
  dummy: '/images/dummyImg.svg',
  emptydata: '/images/empty_data.svg',

  messageReceivedAudio: '/audio/message_received.wav'
}

export default appassets
